(function () {
  const BTN_BG = '#121212';
  const BTN_TEXT = '#ffffff';
  const STAR_GOLD = '#ffb800';
  const TEAL = '#108474';

  const OVERRIDE_CSS = `
html body #judgeme_product_reviews,
html body #judgeme_product_reviews .jdgm-widget,
html body #judgeme_product_reviews .jdgm-rev-widg,
html body #judgeme_product_reviews .jm-review-widget,
html body #judgeme_product_reviews .jm-review-item,
html body .jdgm-rev-widg,
html body .jdgm-widget-revamp {
  --jdgm-primary-color: ${BTN_BG} !important;
  --jdgm-star-color: ${STAR_GOLD} !important;
  --jdgm-write-review-bg-color: ${BTN_BG} !important;
  --jdgm-write-review-text-color: ${BTN_TEXT} !important;
  --jdgm-paginate-color: ${BTN_BG} !important;
  --jdgm-reviewer-name-color: ${BTN_BG} !important;
  --jm-review-widget-star-and-histogram-color: ${STAR_GOLD} !important;
  --jm-review-widget-button-color: ${BTN_BG} !important;
  --jm-review-widget-button-text-color: ${BTN_TEXT} !important;
  --jm-widget-primary-color: ${BTN_BG} !important;
  --jm-review-widget-form-button-color: ${BTN_BG} !important;
  --jm-review-widget-form-button-text-color: ${BTN_TEXT} !important;
}
html body #judgeme_product_reviews .jm-star-rating,
html body #judgeme_product_reviews .jm-star-rating__font-icon,
html body .jdgm-widget-revamp .jm-star-rating,
html body .jdgm-widget-revamp .jm-star-rating__font-icon {
  color: ${STAR_GOLD} !important;
  -webkit-text-fill-color: ${STAR_GOLD} !important;
}
html body #judgeme_product_reviews .jm-button--primary,
html body .jdgm-widget-revamp .jm-button--primary {
  background: ${BTN_BG} !important;
  background-color: ${BTN_BG} !important;
  border-color: ${BTN_BG} !important;
  color: ${BTN_TEXT} !important;
}
html body #judgeme_product_reviews .jdgm-write-rev-link,
html body #judgeme_product_reviews .jdgm-btn--solid,
html body #judgeme_product_reviews .jdgm-rev-widg__actions .jdgm-write-rev-link,
html body #judgeme_product_reviews .jdgm-rev-widg__actions .jdgm-btn--solid,
html body #judgeme_product_reviews .jdgm-rev-widg__actions .jdgm-btn,
html body .jdgm-rev-widg .jdgm-write-rev-link,
html body .jdgm-rev-widg .jdgm-btn--solid {
  background: ${BTN_BG} !important;
  background-color: ${BTN_BG} !important;
  border-color: ${BTN_BG} !important;
  color: ${BTN_TEXT} !important;
}
html body #judgeme_product_reviews .jdgm-btn--border,
html body .jdgm-rev-widg .jdgm-btn--border {
  color: ${BTN_BG} !important;
  border-color: rgba(18, 18, 18, 0.25) !important;
  background: #fff !important;
}
html body #judgeme_product_reviews .jdgm-rev__title,
html body .jdgm-rev-widg .jdgm-rev__title {
  font-size: 1.35rem !important;
  font-weight: 600 !important;
  line-height: 1.35 !important;
}
html body #judgeme_product_reviews .jdgm-rev__body,
html body #judgeme_product_reviews .jdgm-rev__body p,
html body .jdgm-rev-widg .jdgm-rev__body,
html body .jdgm-rev-widg .jdgm-rev__body p {
  font-size: 1.25rem !important;
  line-height: 1.55 !important;
}
html body #judgeme_product_reviews .jdgm-rev-widg__header,
html body .jdgm-rev-widg .jdgm-rev-widg__header {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 0.8rem 1.2rem !important;
}
html body .jdgm-rev-widg__tab[data-tab*='store'],
html body .jdgm-rev-widg__tab[data-tab*='shop'],
html body .jdgm-rev-widg__subtab[data-subtab*='store'],
html body .jdgm-rev-widg__subtab[data-subtab*='shop'],
html body .jdgm-subtab[data-subtab*='store'],
html body .jdgm-subtab[data-subtab*='shop'],
html body [data-tab-content='store-reviews'],
html body [data-tab-content='shop-reviews'],
html body .jdgm-store-reviews,
html body .jdgm-shop-reviews {
  display: none !important;
}
html body #judgeme_product_reviews .jm-average-rating-display .jm-verified-badge,
html body #judgeme_product_reviews .jm-review-widget-minimal-header .jm-verified-badge,
html body #judgeme_product_reviews .jm-review-widget__header .jm-verified-badge,
html body .jdgm-widget-revamp .jm-average-rating-display .jm-verified-badge,
html body .jdgm-widget-revamp .jm-review-widget-minimal-header .jm-verified-badge,
html body .jdgm-widget-revamp .jm-review-widget__header .jm-verified-badge {
  display: none !important;
}
`;

  let scanQueued = false;
  let scanRunning = false;
  let pollCount = 0;
  let pollTimer = null;
  let domObserver = null;
  let lastScanAt = 0;

  function injectOverrides() {
    let node = document.getElementById('ffs-jdgm-overrides');
    if (!node) {
      node = document.createElement('style');
      node.id = 'ffs-jdgm-overrides';
      node.textContent = OVERRIDE_CSS;
      document.body.appendChild(node);
      return;
    }

    if (node.textContent !== OVERRIDE_CSS) {
      node.textContent = OVERRIDE_CSS;
    }
  }

  function patchJudgeMeBrandStyles() {
    document.querySelectorAll('style').forEach((node) => {
      if (node.id === 'ffs-jdgm-overrides' || node.id === 'ffs-jdgm-star-fix' || !node.textContent) return;
      if (!node.textContent.includes('108474') && !node.textContent.includes(TEAL)) return;

      node.textContent = node.textContent
        .replace(/--jdgm-primary-color:\s*[^;]+/gi, `--jdgm-primary-color: ${BTN_BG}`)
        .replace(/--jdgm-star-color:\s*[^;]+/gi, `--jdgm-star-color: ${STAR_GOLD}`)
        .replace(/--jdgm-write-review-bg-color:\s*[^;]+/gi, `--jdgm-write-review-bg-color: ${BTN_BG}`)
        .replace(/--jdgm-paginate-color:\s*[^;]+/gi, `--jdgm-paginate-color: ${BTN_BG}`)
        .replace(/--jdgm-reviewer-name-color:\s*[^;]+/gi, `--jdgm-reviewer-name-color: ${BTN_BG}`)
        .replace(/--jm-review-widget-star-and-histogram-color:\s*[^;]+/gi, `--jm-review-widget-star-and-histogram-color: ${STAR_GOLD}`)
        .replace(/--jm-widget-primary-color:\s*[^;]+/gi, `--jm-widget-primary-color: ${BTN_BG}`)
        .replace(/--jm-review-widget-button-color:\s*[^;]+/gi, `--jm-review-widget-button-color: ${BTN_BG}`)
        .replace(/--jm-review-widget-form-button-color:\s*[^;]+/gi, `--jm-review-widget-form-button-color: ${BTN_BG}`)
        .replace(/background-color:\s*#108474/gi, `background-color: ${BTN_BG}`)
        .replace(/background:\s*#108474/gi, `background: ${BTN_BG}`)
        .replace(/border-color:\s*#108474/gi, `border-color: ${BTN_BG}`)
        .replace(/#108474/gi, BTN_BG);
    });
  }

  function patchRevampInlineVars(root) {
    root.querySelectorAll('.jm-review-widget, .jm-review-item, [style*="108474"], [style*="jm-review-widget-star"]').forEach((el) => {
      el.style.setProperty('--jm-review-widget-star-and-histogram-color', STAR_GOLD, 'important');
      el.style.setProperty('--jm-review-widget-button-color', BTN_BG, 'important');
      el.style.setProperty('--jm-review-widget-button-text-color', BTN_TEXT, 'important');
      el.style.setProperty('--jm-widget-primary-color', BTN_BG, 'important');
      el.style.setProperty('--jm-review-widget-form-button-color', BTN_BG, 'important');
      el.style.setProperty('--jm-review-widget-form-button-text-color', BTN_TEXT, 'important');
    });

    root.querySelectorAll('.jm-star-rating, .jm-star-rating__font-icon').forEach((star) => {
      star.style.setProperty('color', STAR_GOLD, 'important');
      star.style.setProperty('-webkit-text-fill-color', STAR_GOLD, 'important');
      star.style.setProperty('--17d289b0', STAR_GOLD, 'important');
    });

    // Pagination uses its own quiet, text-only controls.
    root.querySelectorAll('.jm-button--primary:not(.jm-pagination-controls__button)').forEach((btn) => {
      btn.style.setProperty('background', BTN_BG, 'important');
      btn.style.setProperty('background-color', BTN_BG, 'important');
      btn.style.setProperty('border-color', BTN_BG, 'important');
      btn.style.setProperty('color', BTN_TEXT, 'important');
    });
  }

  function applyDirectStyles(root) {
    patchRevampInlineVars(root);

    root.querySelectorAll('.jdgm-write-rev-link, .jdgm-btn--solid, .jdgm-rev-widg__actions .jdgm-btn').forEach((btn) => {
      btn.style.setProperty('background', BTN_BG, 'important');
      btn.style.setProperty('background-color', BTN_BG, 'important');
      btn.style.setProperty('border-color', BTN_BG, 'important');
      btn.style.setProperty('color', BTN_TEXT, 'important');
    });

    root.querySelectorAll('.jdgm-rev__title').forEach((title) => {
      title.style.setProperty('font-size', '1.35rem', 'important');
      title.style.setProperty('line-height', '1.35', 'important');
    });

    root.querySelectorAll('.jdgm-rev__body, .jdgm-rev__body p').forEach((body) => {
      body.style.setProperty('font-size', '1.25rem', 'important');
      body.style.setProperty('line-height', '1.55', 'important');
    });
  }

  function labelButton(button, className, text) {
    if (!button || button.dataset.ffsLabeled === 'true') return;
    button.dataset.ffsLabeled = 'true';
    button.classList.add('ffs-jdgm-btn', className);
    button.setAttribute('aria-label', text);
    button.setAttribute('title', text);

    if (!button.querySelector('.ffs-jdgm-btn__text')) {
      const label = document.createElement('span');
      label.className = 'ffs-jdgm-btn__text';
      label.textContent = text;
      button.appendChild(label);
    }
  }

  function enhanceActionButtons(root) {
    const writeBtn = root.querySelector('.jdgm-write-rev-link, .jdgm-rev-widg__actions .jdgm-btn--solid');
    if (writeBtn) {
      writeBtn.style.display = '';
      writeBtn.removeAttribute('hidden');
    }

    const actionButtons = root.querySelectorAll(
      '.jdgm-rev-widg__actions button, .jdgm-rev-widg__actions [role="button"], .jdgm-rev-widg__sort-wrapper button, .jdgm-rev-widg__sort-wrapper [role="button"], .jdgm-rev-widg__actions .jdgm-btn--border, .jdgm-rev-widg__actions .jdgm-btn'
    );

    const iconButtons = Array.from(actionButtons).filter(
      (btn) => !btn.classList.contains('jdgm-write-rev-link') && !btn.classList.contains('jdgm-btn--solid')
    );

    iconButtons.forEach((button, index) => {
      const hint = (
        button.getAttribute('aria-label') ||
        button.getAttribute('title') ||
        button.textContent ||
        ''
      ).trim();

      if (/filter/i.test(hint)) {
        labelButton(button, 'ffs-jdgm-btn--filter', 'Filter');
      } else if (/sort/i.test(hint)) {
        labelButton(button, 'ffs-jdgm-btn--sort', 'Sort');
      } else if (index === 0) {
        labelButton(button, 'ffs-jdgm-btn--filter', 'Filter');
      } else if (index === 1) {
        labelButton(button, 'ffs-jdgm-btn--sort', 'Sort');
      }
    });
  }

  function hideStoreReviewsTab(root) {
    const widget = root.matches('.jdgm-rev-widg') ? root : root.querySelector('.jdgm-rev-widg');
    if (!widget) return;

    widget
      .querySelectorAll(
        '.jdgm-rev-widg__tab, .jdgm-rev-widg__subtab, .jdgm-subtab, [role="tab"], .jdgm-rev-widg__subtabs a, .jdgm-rev-widg__subtabs button'
      )
      .forEach((tab) => {
        const tabKey = (
          tab.getAttribute('data-tab') ||
          tab.getAttribute('data-subtab') ||
          tab.getAttribute('href') ||
          ''
        ).toLowerCase();
        const label = (tab.textContent || '').trim().toLowerCase();
        if (
          tabKey.includes('shop') ||
          tabKey.includes('store') ||
          /store reviews?|shop reviews?/.test(label)
        ) {
          tab.remove();
        }
      });

    widget
      .querySelectorAll(
        '[data-tab-content="shop-reviews"], [data-tab-content="store-reviews"], .jdgm-rev-widg__shop-reviews, .jdgm-shop-reviews, .jdgm-store-reviews'
      )
      .forEach((panel) => panel.remove());

    widget.querySelectorAll('.jdgm-write-rev-link, .jdgm-btn, a, button').forEach((node) => {
      const label = (node.textContent || '').trim().toLowerCase();
      if (/write a store review|write store review/.test(label)) {
        node.remove();
      }
    });

    widget.querySelectorAll('.jdgm-rev-widg__tabs, .jdgm-rev-widg__subtabs').forEach((wrapper) => {
      const remaining = wrapper.querySelectorAll('.jdgm-rev-widg__tab, .jdgm-rev-widg__subtab, .jdgm-subtab, [role="tab"]');
      if (remaining.length <= 1) {
        wrapper.remove();
      }
    });
  }

  function hideEmptyReviewSections() {
    document.querySelectorAll('#judgeme_product_reviews, .jdgm-rev-widg').forEach((root) => {
      const widget = root.matches('.jdgm-rev-widg') ? root : root.querySelector('.jdgm-rev-widg');
      if (!widget) return;

      const countAttr = widget.getAttribute('data-number-of-reviews');
      const reviewCount = countAttr ? parseInt(countAttr, 10) : NaN;
      if (!Number.isNaN(reviewCount) && reviewCount > 0) {
        const section = widget.closest('section.section, .shopify-section');
        if (section) {
          section.classList.remove('ffs-jdgm-section--empty');
          section.removeAttribute('hidden');
          section.removeAttribute('aria-hidden');
        }
        widget.classList.remove('jdgm-temp-hidden');
        widget.style.removeProperty('display');
        return;
      }

      const hasReviews = widget.querySelector('.jdgm-rev:not(.jdgm-rev__sample)') !== null;
      const emptyText = /be the first to write a review|hasn't received any reviews yet|no reviews yet/i.test(
        widget.textContent || ''
      );
      const isEmpty = (!hasReviews && (Number.isNaN(reviewCount) || reviewCount === 0)) || (emptyText && !hasReviews);

      const section = widget.closest('section.section, .shopify-section');
      if (!section) return;

      if (isEmpty) {
        section.classList.add('ffs-jdgm-section--empty');
        section.setAttribute('hidden', '');
        section.setAttribute('aria-hidden', 'true');
      } else {
        section.classList.remove('ffs-jdgm-section--empty');
        section.removeAttribute('hidden');
        section.removeAttribute('aria-hidden');
      }
    });

    document.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
      const rating = parseFloat(badge.getAttribute('data-average-rating') || '0');
      if (rating <= 0) {
        badge.classList.add('ffs-jdgm-badge--empty');
        badge.setAttribute('hidden', '');
      }
    });
  }

  function scan() {
    if (scanRunning) return;
    const now = Date.now();
    if (now - lastScanAt < 120) return;
    scanRunning = true;
    lastScanAt = now;

    if (domObserver) domObserver.disconnect();

    try {
      patchJudgeMeBrandStyles();
      injectOverrides();

      document.querySelectorAll('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-widget-revamp').forEach((root) => {
        const widget =
          root.matches('.jdgm-rev-widg, .jdgm-widget-revamp, #judgeme_product_reviews')
            ? root
            : root.querySelector('.jdgm-rev-widg, .jdgm-widget-revamp, .jm-review-widget');
        if (!widget) return;

        widget.classList.remove('jdgm-temp-hidden');
        widget.style.removeProperty('display');
        document.querySelectorAll('style.jdgm-temp-hiding-style').forEach((node) => node.remove());

        applyDirectStyles(root);
        enhanceActionButtons(root);
        hideStoreReviewsTab(root);
      });

      hideEmptyReviewSections();
    } finally {
      scanRunning = false;
      observeJudgeMe();
    }
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(() => {
      scanQueued = false;
      scan();
    });
  }

  function startPolling() {
    if (pollTimer) return;
    pollTimer = window.setInterval(() => {
      pollCount += 1;
      queueScan();
      if (pollCount >= 24) {
        window.clearInterval(pollTimer);
        pollTimer = null;
      }
    }, 1000);
  }

  function observeJudgeMe() {
    if (domObserver) domObserver.disconnect();

    const watchTarget = document.getElementById('judgeme_product_reviews');
    if (!watchTarget) return;

    domObserver = new MutationObserver((mutations) => {
      const shouldScan = mutations.some((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'href' && mutation.target instanceof HTMLLinkElement) {
          return true;
        }
        return Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof HTMLElement &&
            !node.id?.startsWith('ffs-jdgm') &&
            !node.classList?.contains('ffs-jdgm-btn__text') &&
            (node.matches?.('.jdgm-rev-widg, .jdgm-rev, .jm-review-widget, .jm-review-item, .jm-star-rating, link') ||
              node.querySelector?.('.jdgm-rev-widg, .jdgm-rev, .jm-review-widget, .jm-review-item, .jm-star-rating'))
        );
      });
      if (shouldScan) queueScan();
    });

    domObserver.observe(watchTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href', 'style', 'class'],
    });
  }

  function init() {
    scan();
    startPolling();

    document.addEventListener('jdgm.doneLoadingCss', queueScan, { once: true });
    document.addEventListener('jdgm.widgetLoaded', queueScan);
    document.addEventListener('jdgm.doneLoadingWidget', queueScan, { once: true });
    window.addEventListener('load', queueScan, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
